module.exports = __webpack_public_path__ + "img/CH.9c0735c8.svg";